import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcpButtonModule, FcpIconModule } from 'fc-ui-components';

import { CreateStoreDialogComponent } from './create-store-dialog.component';
import { SharedModule } from 'shared/shared.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { FormsModule } from 'app/order-management/retailer-platform/manage-stores/shared/forms/forms.module';

@NgModule({
    imports: [CommonModule, TranslateModule, ModalModule, FcpButtonModule, FormsModule, SharedModule, FcpIconModule],
    declarations: [CreateStoreDialogComponent],
    exports: [CreateStoreDialogComponent]
})
export class CreateStoreDialogModule {}
